/**
 * Internal dependencies
 */
import WMUWCCart from "./cart";

/**
 * 
 */
const cart = new WMUWCCart( {
	actionAdd: wmuwcCartArgs.actionAdd,
	actionRemove: wmuwcCartArgs.actionRemove,
	actionSingleAdd: wmuwcCartArgs.actionSingleAdd,
	actionUpdate: wmuwcCartArgs.actionUpdate,
	actionUpdateCount: wmuwcCartArgs.actionUpdateCount,
	ajaxUrl: wmuwcCartArgs.ajaxUrl,
	displayMiniCartOnAddProduct: wmuwcCartArgs.displayMiniCartOnAddProduct,
	isCartPage: wmuwcCartArgs.isCartPage,
	nonce: wmuwcCartArgs.nonce,
} );

/**
 * 
 */
document.addEventListener( 'DOMContentLoaded', ( event ) =>
{
	cart.initAddToCartButtons();
	cart.initOpenCartButtons();
	cart.initSingleAddToCartForm();
	cart.updateCount();

	if ( wmuwcCartArgs.isCartPage )
	{
		const mainCartFormElement = document.querySelector( '.wp-site-blocks form.woocommerce-cart-form' );

		if ( mainCartFormElement )
		{
			cart.initRemoveFromCartButtons( mainCartFormElement );
			cart.initQuantityInputs( mainCartFormElement );
		}
	}

	/**
	 * Debug
	 */
	// cart.openMiniCart();
	// cart.update();
} );

window.addEventListener( 'wmuwpblocks/archive/itemsAdded', ( event ) =>
{
	cart.initAddToCartButtons( event.detail.archive.element );
} );

/**
 * @todo Mettre en place un relai des events de Cart via jQuery pour trigger les events woocommerce
 * 
 * applied_coupon woocommerce\assets\js\frontend\cart.js
 * removed_coupon woocommerce\assets\js\frontend\cart.js
 */
window.addEventListener( 'wmuwc/addedToCart', ( event ) =>
{
	const $thisbutton = ( event.detail.elementCaller ) ? jQuery( event.detail.elementCaller ) : null;

	if ( $thisbutton )
	{
		jQuery( document.body ).trigger( 'added_to_cart', [ '', '', $thisbutton ] );
	}
} );

window.addEventListener( 'wmuwc/removedFromCart', ( event ) =>
{
	const $thisbutton = ( event.detail.elementCaller ) ? jQuery( event.detail.elementCaller ) : null;

	if ( $thisbutton )
	{
		jQuery( document.body ).trigger( 'removed_from_cart', [ '', '', $thisbutton ] );
	}
} );

window.addEventListener( 'wmuwc/singleAddedToCart', ( event ) =>
{
	const $thisbutton = ( event.detail.elementCaller ) ? jQuery( event.detail.elementCaller ) : null;

	if ( $thisbutton )
	{
		jQuery( document.body ).trigger( 'added_to_cart', [ '', '', $thisbutton ] );
	}
} );

export { cart };